import {GET_STAFF_LIST, GET_SERVICE_LIST, GET_STAFF_SERVICE_LIST, GET_WORKING_HOUR, GET_CHECKIN_STAFF, LIST_COMMISSION_BY_STAFF, GET_PERMISSION_LIST} from "./staffListTypes";
import { Staff } from "../../models/staff";
import { Category } from "../../models/category";
import { StaffService } from "../../models/staff_service";

export default {
    [GET_STAFF_LIST](state, data) {
      state.staffData = data;
      let staff_arr = [];
      if(data != null) {
        for(let i = 0; i < data.items.length; i++) {
          staff_arr.push(new Staff(data.items[i]));
        }
      }
      state.staffList = staff_arr;
    },
    [GET_WORKING_HOUR](state, workingHour) {
      state.workingHours = workingHour;
    },
    [GET_SERVICE_LIST](state, data) {
      state.serviceData = data;
      let service_arr = [];
      for(let i = 0; i < data.items.length; i++) {
        service_arr.push(new Category(data.items[i]));
      }
      state.serviceList = service_arr;
    },
    [GET_STAFF_SERVICE_LIST](state, data) {
      state.staffServiceData = data;
      let staff_service_arr = [];
      if(data != null) {
        for(let i = 0; i < data.items.length; i++) {
          staff_service_arr.push(new StaffService(data.items[i]));
        }
      }
      state.staffServiceList = staff_service_arr;
    },
    [GET_CHECKIN_STAFF](state, data) {
      state.checkinStaff = data;
    },
    [LIST_COMMISSION_BY_STAFF](state, data) {
      state.commissionList = data;
    },
    [GET_PERMISSION_LIST](state, data) {
      state.permissionList = data;
    }
  }
